const sumPriceAndDiscount = (sales) => {
  let totalPrice = 0;
  let totalDiscount = 0;

  for (const sale of sales) {
    totalPrice += Number.parseFloat(sale?.total) || 0;
    totalDiscount += Number.parseFloat(sale?.discount) || 0;
  }

  return { totalPrice, totalDiscount };
};

export const calculateTotalsOnProductSalesData = (data) => {
  const sales = [];

  for (const key of Object.keys(data)) {
    sales.push({ total: data[key].price, discount: data[key].discount });
  }

  return sumPriceAndDiscount(sales);
};

export const calculateTotalsOnServiceSalesData = (data) => {
  const sales = [];

  for (const key of Object.keys(data)) {
    sales.push({ total: data[key].price, discount: data[key].discount });
  }

  return sumPriceAndDiscount(sales);
};
